module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-95.b2718752.svg";